import React from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import {
  INLINE_TYPES,
  TECH_CONNECT_CODE,
  APPOINTMENT_STATUSES,
  HOLD_MY_SPOT_VISIT_TYPE_CODE,
} from '../../../../../constants';
import Button from '../../../../Button';
import ConfirmVisitByPatientBtn from '../../ConfirmVisitByPatientBtn';
import styles from './styles.styl';

function AppointmentHeader({
  hasMandatoryPaymentWarning,
  providerContext,
  appointment,
  formatMessage,
  onCheckIn,
  onNoShow,
  onComplete,
  disabled,
}) {
  const status = get(appointment, 'status.coreAppName');
  const code = get(appointment, 'visitType.code');
  const isConfirmedByPatient = get(appointment, 'confirmed');
  const { checkIn, checkInPossible } = get(appointment, 'allowedActions') || {};
  const isConfirmByPatientEnabled = get(appointment, 'canConfirmVisit');
  const appointmentFormattedDuration = get(appointment, 'formattedDuration');
  const prohibitConfirmationForPatientByReasonType = get(
    appointment,
    'reasonType.prohibitConfirmationForPatient',
    false,
  );

  const isNotCheckedIn = checkIn === false;
  const isConfirmByPatientForbidden = isConfirmByPatientEnabled === false;
  const isHoldMySpotVisitType = code === HOLD_MY_SPOT_VISIT_TYPE_CODE;

  function renderNoShowBtn() {
    return (
      <Button
        onClick={onNoShow}
        styleName="btn"
        color="transparent"
        disabled={disabled}
      >
        {formatMessage({ id: 'appointment.actions.noShow' })}
      </Button>
    );
  }

  function renderCompleteBtn() {
    return (
      <Button
        onClick={onComplete}
        color="transparent"
        styleName="btn"
        disabled={disabled}
      >
        {formatMessage({ id: 'appointment.actions.complete' })}
      </Button>
    );
  }

  function renderCheckInBtn() {
    return (
      <Button onClick={onCheckIn} color="primary" raised disabled={disabled}>
        {formatMessage({ id: 'appointment.actions.checkIn' })}
      </Button>
    );
  }

  switch (status) {
    case APPOINTMENT_STATUSES.IN_PROCESS: {
      if (code === TECH_CONNECT_CODE) {
        return null;
      }

      if (providerContext) {
        return (
          <div styleName="in-progress">
            {renderNoShowBtn()}
            {renderCompleteBtn()}
          </div>
        );
      }

      return <span styleName="status">{status}</span>;
    }

    case APPOINTMENT_STATUSES.CHECKED_IN: {
      if (providerContext) {
        return (
          <div styleName="in-progress">
            {renderNoShowBtn()}
            {renderCompleteBtn()}
          </div>
        );
      }

      return <span styleName="status">{status}</span>;
    }

    case APPOINTMENT_STATUSES.UPCOMING: {
      let showStatus;

      if (providerContext) {
        return renderNoShowBtn();
      }

      if (INLINE_TYPES.includes(code)) {
        return null;
      }

      if (checkIn && checkInPossible && !isHoldMySpotVisitType) {
        if (hasMandatoryPaymentWarning) {
          return (
            <span styleName="status">
              {formatMessage({ id: 'appointment.actions.checkIn.warning' })}
            </span>
          );
        }
        return renderCheckInBtn();
      }

      if (
        isConfirmByPatientEnabled &&
        !prohibitConfirmationForPatientByReasonType
      ) {
        return (
          <ConfirmVisitByPatientBtn
            userId={appointment.userId}
            appointmentId={appointment.id}
            type="primary"
          />
        );
      }

      if (
        !prohibitConfirmationForPatientByReasonType &&
        isConfirmByPatientForbidden &&
        isConfirmedByPatient === false &&
        isNotCheckedIn &&
        !isHoldMySpotVisitType
      ) {
        showStatus = formatMessage({
          id: 'appointment.actions.availableConfirm',
        });
      }

      if (
        ((isConfirmByPatientForbidden && isConfirmedByPatient === true) ||
          prohibitConfirmationForPatientByReasonType) &&
        isNotCheckedIn &&
        !isHoldMySpotVisitType
      ) {
        const i18n = hasMandatoryPaymentWarning
          ? 'appointment.actions.checkIn.warning'
          : 'appointment.actions.availableCheckInTime';

        showStatus = formatMessage({ id: i18n });
      }

      if (!checkInPossible) {
        return null;
      }

      return <span styleName="status">{showStatus}</span>;
    }

    case APPOINTMENT_STATUSES.COMPLETED: {
      return (
        <div className={styles.durationWrapper}>
          <div className={styles.durationTitle}>
            {formatMessage({ id: 'appointment.details.visitDuration.title' })}
          </div>
          <div className={styles.durationValue}>
            {appointmentFormattedDuration}
          </div>
        </div>
      );
    }

    default:
      return (
        <span styleName="status">
          {isConfirmedByPatient
            ? `${status}/${formatMessage({ id: 'common.confirmed' })}`
            : status}
        </span>
      );
  }
}

AppointmentHeader.propTypes = {
  disabled: PropTypes.bool,
  onNoShow: PropTypes.func,
  onCheckIn: PropTypes.func,
  onComplete: PropTypes.func,
  formatMessage: PropTypes.func,
  appointment: PropTypes.object,
  providerContext: PropTypes.bool,
  hasMandatoryPaymentWarning: PropTypes.bool,
};

export default CSSModules(AppointmentHeader, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/AppointmentHeader/index.jsx